// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { setProtectionMetrics } from '../actions'
import { loadingToggler } from 'redux/modules/loading'
import { fetchWrapper } from 'helpers/api'

const getProtectionMetrics = () => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      const { protectionMetrics } = getState().protection

      if (protectionMetrics.dataExpiration > Date.now()) {
        return protectionMetrics.data
      }

      try {
        const res = await fetchWrapper(`/protectionMetrics`)
        dispatch(setProtectionMetrics(res))
        return res
      } catch (err) {
        console.warn(err)
        throw err
        // TODO NEXT - add notification here once it's set up.
      }
    })
  )
)

export default getProtectionMetrics
